<template>
  <div class=ccpit>
    <div v-if="facility=='app'" class="content">
      <AbApp/>
    </div>
    <div v-else>
      <!-- <Banner/> -->
    </div>
  </div>
</template>

<script>
import AbApp from "./app";
export default {
  components:{
    AbApp,
  },
  data(){
    return{
      facility:""
    }
  },
  beforeMount(){
    this.facility = this.isMobile()
  },
  methods:{
    
  }
}
</script>

<style scoped>
  .ccpit,
  .app{
    height: 100%;
  }
</style>